// https://fslightbox.com/javascript/documentation/basic#events
import fsLightbox from 'fslightbox';

import 'fit-text-webcomponent';
import '../../../src/docReady.js';
import Dom from '../../../src/Dom.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.wp-block-gallery';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo wp-block-gallery');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1(); },100); // prima l'immagine centrale
        setTimeout(() => { this.task2(); },500); // prima l'immagine centrale
    }
    
    // _________________________________________________________________________
    
    /**
     * FIT-TEXT
     * @returns {undefined}
     */
    task1() {
        var $galleries = this.$module.querySelector('.blocks-gallery-grid');
        var $imagelinks = $galleries.querySelectorAll('a');

        $imagelinks.forEach(($el) => {
            $el.setAttribute('data-fslightbox',true);
        });
    };
    
    // _________________________________________________________________________
    
    task2() {
       
        refreshFsLightbox();
        
        // tutti i lightbox-trigger aprono la lightbox gallery di pagina
        // ad esempio: <a href="#" data-lightbox-trigger>Apri la gallery di pagina</a>
        var $lightboxTriggers = this.$module.querySelectorAll('[data-fslightbox]');
        $lightboxTriggers.forEach(($lightboxTrigger,i) => {
            $lightboxTrigger.addEventListener('click',(e) => {
                e.preventDefault();
                
                // apre la lightbox
                let galleryId = $lightboxTrigger.getAttribute('data-fslightbox');
                fsLightboxInstances[galleryId].open(0);
            });
            
        });
    };
    
}

// export
export default new Module();